import React, {useEffect, useRef, useState} from 'react';
import {EditOutlined} from '@ant-design/icons';
import {Input} from 'antd';
import {isNotBlank} from '../reducers/util';
import classNames from "classnames";
import styles from "./EditableLabel.module.scss";


type EditableLabelProps = {
    text?: string
    className?: string
    dataTestId?: string
    onSaveNotification: (value: string) => void
}

// https://ant.design/components/table/#components-table-demo-edit-cell
const EditableLabel = ({ text = 'some text here', onSaveNotification, className = undefined, dataTestId }: EditableLabelProps) => {
    const [editing, setEditing] = useState(false)
    const [value, setValue] = useState(text)
    const textInput = useRef<Input>(null)

    const toggleEdit = () => {
        setEditing(!editing)
    }

    useEffect(() => {
        setValue(text)
        if (editing && textInput.current) {
            textInput.current.focus()
        }
    }, [editing, text, textInput])

    const onSave = (e: (React.FocusEvent<HTMLInputElement, Element> | React.KeyboardEvent<HTMLInputElement>)) => {
        toggleEdit()
        const enteredValue = (e.target as any).value as string
        if (isNotBlank(enteredValue)) {
            setValue(enteredValue)
            onSaveNotification(enteredValue)
        }
    }

    const input = <Input
        className={classNames(styles.editableLabel, className)}
        style={{ 'width': (value.length + 20) + 'ch' }}
        defaultValue={value}
        size="small"
        ref={textInput}
        onPressEnter={e => onSave(e)}
        onBlur={e => onSave(e)}
        data-testid={dataTestId}
    />

    const editor = <span
        className={classNames(styles.editableLabel, className)}
        onClick={e => { e.stopPropagation(); toggleEdit() }}
        data-testid={dataTestId}
    >
        {value}<EditOutlined />
    </span>

    return editing ? input : editor
}

export default EditableLabel;